import React from 'react';
import img1 from "../../assets/images/img1.png"
import cvmatthieugrauleau from "../../assets/files/cvmatthieugrauleau.pdf";
console.log(cvmatthieugrauleau)
function CV() {
  return (
    <section className="about" id="about">
      <div className="title reveal">
        <h2 className="section-title">About Me</h2>
      </div>
      <div className="content">
        <div className="column col-left reveal">
          <div className="img-card">
            <img src={img1} alt="galaxy" />
          </div>
        </div>
        <div className="column col-right reveal">
          <h2 className="content-title">Hey There! I'm Matthieu Grauleau</h2>
          <p className="paragraph-text">
          I embarked on my coding journey in early 2023 and, in February, I dove headfirst into OpenClassrooms' web development program. 
		  I then advanced my skills further by completing the intensive training at Holberton School. 
		  I'm a highly motivated individual who quickly grasps new concepts and enjoys collaborating within a team. 
		  I am passionate about web development and eager to secure a job opportunity as soon as possible. 
		  My journey in the world of web development has been marked by dedication, and 
		  I'm excited to apply these qualities in a professional setting.
		  If you'd like to learn more about me, please feel free to download my CV or get in touch with me via email or phone. 
		  You can find my contact information at the bottom of this website.
          </p>
          <a href={cvmatthieugrauleau}  download="cvmatthieugrauleau.pdf"  className="button">Download my CV</a>
        </div>
      </div>
    </section>
  );
}

export default CV;
